import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IGift } from '@app/gifts/models/gift.interface';

@Component({
  selector: 'app-gifts-list-item',
  templateUrl: './gifts-list-item.component.html',
  styleUrls: ['./gifts-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftsListItemComponent {
  @Input() gift: IGift;

  constructor(
    private router: Router,
    private route: ActivatedRoute) { }

  goToGiftDetailsPage() {
    this.router.navigate([
      'gifts',
      'details',
      this.route.snapshot.paramMap.get('visitId'),
      this.gift.giftId
    ]);
  }

}
